import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-user-maintainence',
    templateUrl: './user-maintainence.component.html',
    styleUrls: ['./user-maintainence.component.scss'],
    standalone: false
})
export class UserMaintainenceComponent implements OnInit {

  constructor(private router:Router) { }

  ngOnInit(): void {
  }


  
}
